import {isExpired, decodeToken} from "react-jwt";
import {redirect, useNavigate} from "react-router-dom";

const RouterProtector = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        console.log('RouterProtector');
        return redirect('/');
    }
    return true;
}

export default RouterProtector;
